<script setup>
defineProps({
  brandName: { type: String, default: "Twoja Firma" },
  brandTagline: {
    type: String,
    default:
      "Projektujemy nowoczesne strony i aplikacje — przejrzyście, szybko i bez zbędnego kodu.",
  },
  // sitemap: [{ label: 'Start', href: '#start' }, ...]
  siteMap: { type: Array, default: () => [] },
  // addressLines: ['Twoja Firma Sp. z o.o.', 'ul. Przykładowa 12', '00-000 Warszawa, Polska']
  addressLines: { type: Array, default: () => [] },
  phone: { type: String, default: "" },
  email: { type: String, default: "" },
});

// const consentRef = ref(null);
// function showCookies() {
//   consentRef.value?.toggleConsentManagement();
// }
</script>

<template>
  <footer id="stopka">
    <!-- <FlexuilibConsent
      ref="consentRef"
      class="iq-card-solid"
      :style="{
        '--color-iq-secondary': '#00bc7d',
      }"
    /> -->
    <!-- Dekoracyjny background w stylu sekcji proces -->

    <div class="mx-auto max-w-7xl py-20">
      <!-- Górna siatka: brand / mapa strony / adres -->
      <div class="grid gap-8 md:grid-cols-3 iq-card-solid">
        <!-- Brand & opis -->
        <div class="p-6">
          <div class="flex gap-3 bg-zinc-950 w-fit px-3 py-2 rounded-md items-center">
            <Logo />
          </div>
          <p v-if="brandTagline" class="mt-3 text-sm leading-relaxed">
            {{ brandTagline }}
          </p>
        </div>

        <!-- Mapa strony -->
        <nav v-if="siteMap && siteMap.length" class="p-6">
          <h3 class="text-sm font-semibold uppercase tracking-wider">Mapa strony</h3>
          <ul class="mt-4 grid grid-cols-2 gap-2 text-sm">
            <li v-for="(item, i) in siteMap" :key="i">
              <NuxtLink :to="item.href" class="">{{ item.label }}</NuxtLink>
            </li>
          </ul>
        </nav>

        <!-- Adres & kontakt -->
        <div class="p-6">
          <h3 class="text-sm font-semibold uppercase tracking-wider">Adres i kontakt</h3>
          <address
            v-if="addressLines && addressLines.length"
            class="not-italic mt-4 text-sm leading-relaxed"
          >
            <template v-for="(line, i) in addressLines" :key="i"
              >{{ line }}<br
            /></template>
          </address>
          <div class="mt-3 text-sm">
            <template v-if="phone"
              ><a :href="`tel:${phone}`" class="">{{ phone }}</a
              ><br
            /></template>
            <template v-if="email"
              ><a :href="`mailto:${email}`" class="">{{ email }}</a></template
            >
          </div>
          <slot name="cta"></slot>
        </div>
      </div>

      <!-- Dolny pasek -->
      <div
        class="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-sm md:flex-row"
      >
        <p>
          © {{ new Date().getFullYear() }} {{ brandName }}. Wszelkie prawa zastrzeżone.
        </p>
        <!-- <div class="flex items-center gap-4">
          <button @click="showCookies" class="">Ustawienia cookies</button>
        </div> -->
      </div>
    </div>
  </footer>
</template>
